import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description }) => (
  <Helmet>
    <title>{title ? `${title} | VetBill` : 'VetBill — Compare Veterinary Costs Near You'}</title>
    {description && <meta name="description" content={description} />}
  </Helmet>
);

export default SEO;
